import {AGGTRADES} from 'actions'
import produce from 'immer'
import PERFORMANCE from 'performance'

const reducer = (state = {}, {type, symbol, response}) => {
  if (type === AGGTRADES) {
    if (response.length > 0) {
      return produce(state, draftState => {
        draftState[symbol] = draftState[symbol] || []
        draftState[symbol] = response.concat(draftState[symbol]).slice(0, PERFORMANCE.TRADES_LIMIT)
      })
    }
  }
  return state
}

export default reducer
